import styled from 'styled-components'

export const HomeImage = styled.div`
  height: 100%;
  > img {
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
    object-position: center;
  }
`

export const SavingsCalcImage = styled.div<{ height: number }>`
  height: 100%;
  max-height: ${(props) => `${props.height}px`};
  min-height: ${(props) => `${props.height}px`};
  > img {
    min-width: 100%;
    max-height: 100%;
    min-height: 100%;
    object-fit: cover;
    object-position: center;
  }
`

export const RadioCardContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`
export const RadioCard = styled.div`
  display: flex;
  height: 100%;
  cursor: pointer;
`

export const CardContainer = styled.div<{ isMobile?: boolean; card?: string }>`
  padding: ${(props) => (props.isMobile ? '32px 16px' : '48px 32px')};
`

export const CtaContainer = styled.div<{ justifyContent?: string }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
`

export const DeviceValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
`

export const DeviceInfoContainer = styled.div<{ isMobile: boolean }>`
  display: ${(props) => (props.isMobile ? 'block' : 'flex')};
`

export const ValueContainer = styled.div<{ isMobile: boolean }>`
  margin-top: ${(props) => (props.isMobile ? '16px' : '24px')};
`

export const TotalSavingsValueContainer = styled.div`
  display: flex;
  align-items: flex-end;
`

export const HomeSelectionsTextContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

export const HomeSelectionsMobileContainer = styled.div`
  width: 100%;
  height: 100%;
  margin: 8px 0;
`

export const Step1CtaContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`
